module.exports = __webpack_public_path__ + "static/media/patrick-maccory-200x200.a4cf5914.jpg";